var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFictionalIcon = function SvgFictionalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#ff0064",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 16a96.11 96.11 0 0 0-96 96c0 24 12.56 55.06 33.61 83 21.18 28.15 44.5 45 62.39 45s41.21-16.81 62.39-45c21.05-28 33.61-59 33.61-83a96.11 96.11 0 0 0-96-96M64 116a12 12 0 0 1 12-12 36 36 0 0 1 36 36 12 12 0 0 1-12 12 36 36 0 0 1-36-36m80 84h-32a8 8 0 0 1 0-16h32a8 8 0 0 1 0 16m12-48a12 12 0 0 1-12-12 36 36 0 0 1 36-36 12 12 0 0 1 12 12 36 36 0 0 1-36 36"
  })));
};
export default SvgFictionalIcon;